import React from "react";

export default function Mail(props: any) {
  return <div>{JSON.stringify(props.selectedEmail)}</div>;
}
